// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__cnJc1","inputDescription":"styles_inputDescription__1Nj-j"};